import * as React from 'react';
import * as style from './style.sass';
import { Link } from 'react-router-dom';

export class MainMenu extends React.Component {
  render() {
    return (<div className={style.mainMenu}>
      <Link to="/">Packs</Link>
      <Link to="/purchase-wallpapers">Purchase wallpapers</Link>
    </div>);
  }
}
